import { ErrorType } from '../enums/ErrorType';
import { CRUDActions } from '../enums/CRUDActions';
import { DbTable } from '../enums/DbTable';
import { MessageInfoType } from '../enums/MessageInfoType';

export class MessageInfo
{
    messageNo: number;
    title: string;
    message: string;
    messageType: MessageInfoType = MessageInfoType.general;
    errorType: ErrorType;
    values: any[];
    messageSubject: any;
    crudActionAttempted: CRUDActions;
    table: DbTable;
    fromTable: DbTable;
    referenceId: any;
    parentId: any;
    crudActionAttemptedString: string;
    errorTypeString: string;
    tableString: string;
    fromTableString: string;

    constructor(message: Partial<MessageInfo> = null) {
        if (!message) {
            return;
        }
        Object.assign(this, message);
    }
}